import { useQuery } from "@tanstack/react-query"
import { useParams } from "react-router"

import { getDataPoint } from "@/features/datapoints/api/getDataPoint.ts"
import DataPointEditor from "@/features/datapoints/components/DataPointEditor.tsx"

export default function EditDataPoint() {
  const params = useParams()
  const id = Number(params.id)
  const { data, isPending, isError } = useQuery({
    queryKey: ["dataPoint", { id }],
    queryFn: () => getDataPoint(id),
  })
  if (isPending) return <>Loading</>
  if (isError) return <>Error</>

  return <DataPointEditor dataPoint={data} type={data.$type} />
}
